module.exports = __webpack_public_path__ + "img/button.8b9df321.png";